export default "__VITE_ASSET__DeBRnofj__"